<!--
 * @Author: M.D.
  * @Date: 2020-02-12 15:18:04
 * @LastEditors  : M.D.
  * @Description:
  * @Remarks:
  -->
<template>
  <div class="cloud-login-w" @click="init">正在跳转，请稍后...</div>
</template>

<script>
import API from '@/api/api'
import { mapActions } from 'vuex'

export default {
  props: {},
  data() {
    return {}
  },
  computed: {},

  async created() {
    this.init()

    return
    // http://localhost:9001/js-esp-pc/cloudLogin?nsrsbh=&shxydm=123&sign=
    // http://kentrasoft.com/js-esp-pc/cloudLogin?&op=zzfw&nsrsbh=91510100562015634D&skph=499912192400&enc=z4AupKKIAmWlG6ImtdXCdg==&tm=202002191447;
    // http://localhost:9001/js-esp-pc/cloudLogin?&op=zzfw&nsrsbh=91510100562015634D&skph=499912192400&enc=z4AupKKIAmWlG6ImtdXCdg==&tm=202002191447
    const re = await API.cloudLogin({
      nsrsbh: this.$route.query.nsrsbh,
      // 'shxydm': 'test20200212001',
      shxydm: this.$route.query.shxydm,
      sign: this.$route.query.sign,
      op: this.$route.query.op,
      skph: this.$route.query.skph,
      enc: this.$route.query.enc,
      tm: this.$route.query.tm,
    })

    // sessionStorage.setItem('skph',this.$route.query.skph)
    // sessionStorage.setItem('nsrsbh',this.$route.query.nsrsbh)
    return

    if (re.data.statusCode === '200') {
      if (this.$route.query.op == 'ckzs') {
        this.$router.push({
          name: 'productDetail',
          params: {
            prodId: '1563068746782769154',
            nsrsbh: this.$route.query.nsrsbh,
            skph: this.$route.query.skph,
          },
        })
      } else if (this.$route.query.op == 'fxpg') {
        this.$router.push({
          name: 'robotLogin',
          query: {
            nsrsbh: this.$route.query.nsrsbh,
            skph: this.$route.query.skph,
            op: this.$route.query.op,
          },
        })
      } else if (this.$route.query.op == 'yjsb') {
        this.$router.push({
          name: 'robotLogin',
          query: {
            nsrsbh: this.$route.query.nsrsbh,
            skph: this.$route.query.skph,
            op: this.$route.query.op,
          },
        })
      } else if (this.$route.query.op == 'cxbg') {
        this.$router.push({
          name: 'robotLogin',
          query: {
            nsrsbh: this.$route.query.nsrsbh,
            skph: this.$route.query.skph,
            op: this.$route.query.op,
          },
        })
      } else {
        this.$router.push({ name: 'index' })
      }
      this.setUserInfo(re.data.result)
    } else {
      this.$router.push({
        name: 'index',
        params: { usrStatus: re.data.statusCode },
      })
    }
  },
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    ...mapActions(['setUserInfo']),
    async init() {
      if (this.$route.query.op == 'qdfp') {
        //跳转到全电平台
        this.$nextTick(() => {
          if (this.$route.query.nsrsbh) {
            location.href =
              'https://www.chinaqjwx.cn/qjyweb/#/cloudLogin?nsrsbh=' +
              this.$route.query.nsrsbh+"&skph="+this.$route.query.skph+"&enc="+this.$route.query.enc+"&tm="+this.$route.query.tm+"&kprjaz=1"+"&ckzsaz=1"+"&tzly=1"
          } else {
            location.href = 'https://www.chinaqjwx.cn/qjyweb/#/cloudLogin'
          }
        })

        // this.$router.push({
        //   name: 'index', //index
        //   query: {
        //     op: this.$route.query.op,
        //   },
        // })
        return
      }
      const re = await API.cloudLogin({
        nsrsbh: this.$route.query.nsrsbh,
        // 'shxydm': 'test20200212001',
        shxydm: this.$route.query.shxydm,
        sign: this.$route.query.sign,
        op: this.$route.query.op,
        skph: this.$route.query.skph,
        enc: this.$route.query.enc,
        tm: this.$route.query.tm,
      })
      // sessionStorage.setItem('skph',this.$route.query.skph)
      // sessionStorage.setItem('nsrsbh',this.$route.query.nsrsbh)
      if (re.data.statusCode === '200') {
        if (this.$route.query.op == 'ckzs') {
          this.$router.push({
            name: 'productDetail',
            params: {
              prodId: '1563068746782769154',
              nsrsbh: this.$route.query.nsrsbh,
              skph: this.$route.query.skph,
            },
          })
        } else if (this.$route.query.op == 'fxpg') {
          this.$router.push({
            name: 'robotLogin',
            query: {
              nsrsbh: this.$route.query.nsrsbh,
              skph: this.$route.query.skph,
              op: this.$route.query.op,
            },
          })
        } else if (this.$route.query.op == 'yjsb') {
          this.$router.push({
            name: 'robotLogin',
            query: {
              nsrsbh: this.$route.query.nsrsbh,
              skph: this.$route.query.skph,
              op: this.$route.query.op,
            },
          })
        } else if (this.$route.query.op == 'cxbg') {
          this.$router.push({
            name: 'robotLogin',
            query: {
              nsrsbh: this.$route.query.nsrsbh,
              skph: this.$route.query.skph,
              op: this.$route.query.op,
            },
          })
        } else {
          this.$router.push({ name: 'index' })
        }

        this.setUserInfo(re.data.result)
      } else {
        this.$router.push({
          name: 'index',
          params: { usrStatus: re.data.statusCode },
        })
      }
    },
  },
  components: {},
}
</script>

<style lang="stylus"></style>
